const painPoints = [
  {
    icon: 'ri-question-mark',
    title: 'No Idea Where to Start',
    desc: "The recruiting process is a maze — timelines, portals, eligibility rules. Most parents don't even know there's a right time to begin.",
    color: 'from-red-500/20 to-red-900/10',
    border: 'border-red-500/20',
  },
  {
    icon: 'ri-chat-off-fill',
    title: "Coaches Aren't Responding",
    desc: 'Your athlete is talented — so why is the inbox empty? Generic outreach gets ignored. The right message to the right coach changes everything.',
    color: 'from-orange-500/20 to-orange-900/10',
    border: 'border-orange-500/20',
  },
  {
    icon: 'ri-time-fill',
    title: 'Missing Critical Deadlines',
    desc: 'NCAA eligibility, early signing periods, official visit windows — one missed deadline can cost your athlete their dream school.',
    color: 'from-yellow-500/20 to-yellow-900/10',
    border: 'border-yellow-500/20',
  },
  {
    icon: 'ri-money-dollar-circle-fill',
    title: 'Money Left on the Table',
    desc: "Most families don't negotiate scholarship offers — or don't know they can. The difference between informed and uninformed parents is tens of thousands of dollars.",
    color: 'from-[#f5a623]/20 to-[#d4891a]/10',
    border: 'border-[#f5a623]/20',
  },
];

export default function ProblemSection() {
  return (
    <section id="problem" className="bg-[#060e1a] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/20 rounded-full px-4 py-2 mb-6">
            <i className="ri-error-warning-fill text-red-400 text-sm" />
            <span className="text-red-400 font-body text-xs font-semibold uppercase tracking-widest">The Hard Truth</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight">
            Most Families
            <span className="block text-red-400">Start Too Late.</span>
          </h2>
          <p className="font-body text-lg text-white/60 max-w-2xl mx-auto mt-6 leading-relaxed">
            By the time most parents realize recruiting is a <strong className="text-white">full-time job</strong>, their athlete is already behind. Don't let that be your story.
          </p>
        </div>

        {/* Pain point cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {painPoints.map((point, i) => (
            <div
              key={i}
              className={`relative bg-gradient-to-b ${point.color} border ${point.border} rounded-xl p-6 flex flex-col gap-4 hover:scale-[1.02] transition-transform duration-300 cursor-default`}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#0a1628] rounded-lg border border-white/10">
                <i className={`${point.icon} text-[#f5a623] text-2xl`} />
              </div>
              <h3 className="font-display text-xl font-bold text-white uppercase leading-tight">
                {point.title}
              </h3>
              <p className="font-body text-sm text-white/60 leading-relaxed">
                {point.desc}
              </p>
              <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center">
                <span className="font-display text-4xl font-bold text-white/5">0{i + 1}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom callout */}
        <div className="mt-14 bg-[#f5a623]/10 border border-[#f5a623]/30 rounded-xl p-6 md:p-8 text-center">
          <p className="font-display text-xl md:text-2xl font-bold text-white uppercase">
            The families that <span className="text-[#f5a623]">win scholarships</span> aren't the ones with the most talented athletes.
          </p>
          <p className="font-body text-base text-white/70 mt-3">
            They're the ones who <strong className="text-white">learned the system</strong> — and worked it from Day 1.
          </p>
        </div>
      </div>
    </section>
  );
}
